export default __webpack_public_path__ + "static/media/11.10.25d85c79.jpg";